import { useEffect } from 'react';

function KeypressListener(_ref) {
  var keyCode = _ref.keyCode,
      handler = _ref.handler,
      _ref$keyEvent = _ref.keyEvent,
      keyEvent = _ref$keyEvent === void 0 ? 'keyup' : _ref$keyEvent;

  var handleKeyEvent = function handleKeyEvent(event) {
    if (event.keyCode === keyCode) {
      handler(event);
    }
  };

  useEffect(function () {
    document.addEventListener(keyEvent, handleKeyEvent);
    return function () {
      document.removeEventListener(keyEvent, handleKeyEvent);
    };
  });
  return null;
}

export { KeypressListener };